// ©2024 Austin App House. All rights reserved.
import { normalizeWorkTypesValue } from './normalizeWorkTypes';

export const parseFormDate = (value) => {
  if (value == null || value === '') return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const getDateWithOffset = (date) => {
  const parsed = parseFormDate(date);
  if (!parsed) return undefined;
  const tzOffset = parsed.getTimezoneOffset();
  return new Date(parsed.getTime() + tzOffset * 60 * 1000);
};

export const normalizeWorkOrderFormDates = (values = {}) => {
  if (!values || typeof values !== 'object') return values;
  return {
    ...values,
    startDate: parseFormDate(values.startDate),
    endDate: parseFormDate(values.endDate),
    workTypes: normalizeWorkTypesValue(values.workTypes),
  };
};

export const getLocalISODate = (date, isMaxTime, isUTC) => {
  if (!date) return '';
  const time = isMaxTime ? '23:59:59.999' : '00:00:00.000';
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const pad = number => (number < 10 ? `0${number}` : number);
  return `${year}-${pad(month)}-${pad(day)}T${time}${isUTC ? 'Z' : ''}`;
};

// For date-only fields: anchor the picked calendar day at noon UTC so it never
// crosses a day boundary when read back in a local (negative-offset) timezone.
// Storing midnight UTC caused expenses to shift one day earlier (7/27 -> 7/26).
export const getISODateOnlyUTC = (date) => {
  const parsed = parseFormDate(date);
  if (!parsed) return '';
  const year = parsed.getFullYear();
  const month = parsed.getMonth() + 1;
  const day = parsed.getDate();
  const pad = number => (number < 10 ? `0${number}` : number);
  return `${year}-${pad(month)}-${pad(day)}T12:00:00.000Z`;
};

export const getISODateAndTime = (date, deleteTime, isUTC) => {
  if (!date) return '';
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hours = deleteTime ? 0 : date.getHours();
  const minutes = deleteTime ? 0 : date.getMinutes();
  const pad = number => (number < 10 ? `0${number}` : number);
  return `${year}-${pad(month)}-${pad(day)}T${pad(hours)}:${pad(minutes)}:00.000${isUTC ? 'Z' : ''}`;
};

export const getLocalDateString = value => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-US');
};
